import { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import ViolationsFilters from './components/violations-filter';
import ViolationsGrid from './components/violations-grid';
import { useViolationsManager } from './use-violations-manager';
import { generateViolationTypesForDropdown } from './utils/generateAllViolationTypes';

export type ViolationsGridWithFiltersProps = {
  regionId: string;
  onRowClick?: (params: unknown) => void;
};

function ViolationsGridWithFilters(props: ViolationsGridWithFiltersProps) {
  const { regionId, onRowClick } = props;

  const {
    data,
    page,
    setPage,
    totalRows,
    filters,
    setFilters,
    onStatusChange,
    loading,
    refetch,
  } = useViolationsManager({ regionId });

  const violationTypes = useMemo(
    () => generateViolationTypesForDropdown(data),
    [data]
  );

  // We are using intersection observer because we don't have router setup for the change events
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        // Silently refetch the data when tabs are changed
        refetch();
      }
    },
  });

  return (
    <div className="flex flex-col h-full" ref={ref}>
      <ViolationsFilters
        violationTypes={violationTypes}
        selectedViolationTypes={filters.rawTypes}
        onViolationTypesChange={(rawTypes) =>
          setFilters({ ...filters, rawTypes })
        }
        selectedViolationStatuses={filters.statuses}
        onViolationStatusesChange={(statuses) =>
          setFilters({ ...filters, statuses })
        }
      />

      <div className="h-full rounded-lg shadow-md">
        <ViolationsGrid
          data={data}
          page={page}
          setPage={setPage}
          totalRows={totalRows}
          onRowClick={onRowClick}
          onStatusChange={onStatusChange}
          isLoading={loading}
        />
      </div>
    </div>
  );
}

export default ViolationsGridWithFilters;
